module.exports = __webpack_public_path__ + "assets/arrow-tr-bl.54c687b3.svg";